<template>
  <div class="bg-secondary min-h-screen w-full">
    <slot />
  </div>
</template>

<script setup lang="ts">
useSiteHead()
</script>
